/// <amd-module name="Pipeline/Analytics/PipelineLeadTimeHub/Pipeline.LeadTimeHub" />
import { ContextType, IReportContext } from "Analytics/Shared/Common/Types";
import { getDefinitionIdFromUrl } from "Analytics/Shared/Utils/URLHelper";
import { PipelineAnalyticsPage } from "Pipeline/Analytics/Common/Components/PipelineAnalyticsPage";
import { PipelineAnalyticsHeader } from "Pipeline/Analytics/PipelineAnalyticsHeader/Pipeline.AnalyticsHeader";
import * as Resources from "Pipeline/Analytics/PipelineLeadTimeHub/Resources";
import { PipelineLeadTimeReport } from "Pipeline/Analytics/PipelineLeadTimeReport/Pipeline.LeadTimeReport";
import * as React from "react";
import { Components, IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

export interface IAnalyticsPageState {
    definitionId: number;
    definitionName: string;
    errorText?: string;
}

export class PipelineLeadTimeHub extends VssComponent<IVssComponentProperties, IAnalyticsPageState> {
    private _reportContext: IReportContext;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this.state = {} as IAnalyticsPageState;

        const definitionId = this._getBuildDefinitionId();
        this._reportContext = {
            contextType: ContextType.Build,
            definitionId: definitionId
        } as IReportContext;
    }

    public render() {
        return (
            <PipelineAnalyticsPage
                renderHeader={this._renderHeader}
                getDataValidationPromises={() => []}
                onSetPipelineName={this._handleSetPipelineName}
                onError={this._handleError}
            >
                <PipelineLeadTimeReport definitionId={this._reportContext.definitionId} />
            </PipelineAnalyticsPage>
        );
    }

    private _renderHeader = (): JSX.Element => {
        return (
            <PipelineAnalyticsHeader
                headerTitle={Resources.PipelineLeadTimeReportHeaderText}
                definitionName={this.state.definitionName}
                definitionId={this._reportContext.definitionId}
                hideFilters={true}
            />
        );
    };

    private _handleSetPipelineName = (pipelineName: string) => {
        this.setState({ definitionName: pipelineName });
    };

    private _handleError = (errorText: string) => {
        this.setState({ errorText: errorText });
    };

    private _getBuildDefinitionId(): number {
        return getDefinitionIdFromUrl(this.context.pageContext);
    }
}

Components.add("pipelineLeadTimeHub", PipelineLeadTimeHub);
